<template>
    <div>
        <div>
            <button type="submit" style="float:right; width: 20px !important; height: 20px !important" :class="'btn ' + chatToggleBtnColor + ' tw-my-2 tw-mx-2 tw-p-0'" @click="toggleChat"></button>
        </div>
        <a href="/chats" class="tw-flex tw-space-x-1 " style="width: 85%">
                    
            <i class="gi gi-chat sidebar-nav-icon tw-pt-3"></i>
            <span class="sidebar-nav-mini-hide tw-mr-6">Chats</span>
            <div style="width: 50px">
            <!-- <div v-for="chatId of unopenedChats" > -->
                <div v-if="unopenedChats.length > 0" >
                    <div class="tw-ml-3">    
                        <button class="badge label-danger " @click.prevent="openUnreadChat">!</button>
                    </div>
                </div>
            </div>
        </a>
        
    </div>
</template>

<script>
import Echo from 'laravel-echo';
import axios from 'axios';

export default {
    name: "ChatAlert",

    props:{
        isChatOpen: {

        }
    },
 
    data() {
        return {
            unopenedChats: [],
            chatToggleBtnColor: this.isChatOpen ? "tw-bg-lime-600" : "tw-bg-red-600",
        }
    },
    mounted(){
        
        // Initialize Echo - stuff copied from AccepteHosted
        window.Pusher = require('pusher-js');

            window.Echo = new Echo({
                broadcaster: 'pusher',
                key: 'pusher-key',
                wsHost: window.location.hostname,
                wsPort: 6001,
                wssPort: 6001,
                cluster: 'mt1',
                forceTLS: this.appEnvironment == 'production',
                disableStats: true
            });

            window.Echo.connector.pusher.connection.bind('connected', () => {
                console.log('connected to websocket server');
                
            });

            window.Echo.connector.pusher.connection.bind('unavailable', () => {
                console.log('websocket server unavailable');
                
            });

            // From the Pusher docs:
            // Channels is not supported by the browser. This implies that WebSockets are not natively available and an HTTP-based transport could not be found.
            window.Echo.connector.pusher.connection.bind('failed', () => {
                console.log('pusher failed');
                
            });

            // Connection error
            window.Echo.connector.pusher.connection.bind('error', (error) => {
                console.log('websocket connection error');
                
            });

        this.subscribeToWebsocket();

        this.getUnreadMessageCounts();

        window.Echo.channel('chat-availability') 
                    .listen('ChatAvailability', event => {
                        console.log("event status" + event.status);
                        this.chatToggleBtnColor = event.status == "on" ? "tw-bg-lime-600" : "tw-bg-red-600";
                    })
                    .error(error => {
                        console.error(error.message);
                        console.log('error: did not get ChatAvailability');
                    });
    },

    methods: {
      
        subscribeToWebsocket(){
            
            window.Echo.channel('alert-pia-chat-updated') 
            .listen('AlertPIAChatUpdated', event => {
                
                this.getUnreadMessageCounts();
                
            })
            .error(error => {
                console.error(error.message);
                console.log('error: did not get AlertPIAChatUpdated');
            });
        },

        openUnreadChat(){
            console.log('open unread chat ' + this.unopenedChats);
            this.unopenedChats.forEach(function (chatId) {
                EventBus.$emit('add-chat', chatId);
                console.log('emmitted chatId' + chatId);
            });
            
            this.unopenedChats = [];
        },

        getUnreadMessageCounts(){
            axios.get('/api/chatMessages/unreadCounts?onlyList=true')
                    .then( response => {
                        //console.log('got message counts - ChatAlert');
                        //console.log(this.unopenedChats.length);
                        this.unopenedChats = response.data;
                        
                    });
        },

        toggleChat(){
            console.log('toggleChat');
            axios.get('/chat/toggle')
                    .then(response => {
                        console.log('response:');
                        console.log(response.data);
                        this.chatToggleBtnColor = response.data == 1 ? "tw-bg-lime-600" : "tw-bg-red-600";
                    });
        }
    }
}
</script>

<style>

</style>